<template>
  <div
    v-if="currentRun.getScenario()"
    id="status-container"
    :key="'covidstatus_container_' + currentRun.getCurrentStep()" 
  >
    <div class="row">
      <div class="text-center">
        <span class="scenario">
          <b>Scenario:</b> {{ currentRun.getScenario().title }}</span>
      </div>
      <div class="text-center">
        <b>Lockdown:</b> &nbsp;
        <template v-if="lockdownStatus > 0.5">
          <span class="udm-badge badge badge-green">i</span> On
        </template>
        <template v-else>
          <span class="udm-badge badge badge-black">i</span> Off
        </template>
      </div>
      <div class="text-center">
        <b>Social distancing:</b> &nbsp;
        <template v-if="socialDistancingStatus > 1">
          <span class="udm-badge badge badge-green">i</span> On
        </template>
        <template v-else>
          <span class="udm-badge badge badge-red">i</span> Off
        </template>
      </div>
      <div class="text-center">
        <b>Public confidence:</b> &nbsp;
        <template v-if="publicConfidenceStatus > 2.5">
          <span class="udm-badge badge badge-red">i</span> High
        </template>
        <template v-else-if="publicConfidenceStatus > 1.5">
          <span class="udm-badge badge badge-amber">i</span> Medium
        </template>
        <template v-else>
          <span class="udm-badge badge badge-red">i</span> Low
        </template>
      </div>
      <div class="clearfix" />
    </div>
    <div class="text-right info-button-container">
      <a
        href
        class="info-button"
        @click.prevent="displayModal('covidstatusinfo')"
      >
        <small>
          <span class="badge badge-info">?</span>
          <strong>More info</strong>
        </small>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      lockdownStatus: 0,
      socialDistancingStatus: 0,
      publicConfidenceStatus: 0
    };
  },
  created() {
    const output = this.currentRun.getSavedOutput() || {};

    const lockdownStatuses = output["Lockdown status"] || [0];
    const sdStatuses = output["Applied decelerator"] || [0];
    const pcStatuses = output["Actual public confidence"] || [0];

    this.lockdownStatus = lockdownStatuses[lockdownStatuses.length - 1];
    this.socialDistancingStatus = sdStatuses[sdStatuses.length - 1];
    this.publicConfidenceStatus = pcStatuses[pcStatuses.length - 1];
  },
  methods: {
    displayModal(modalName) {
      this.$root.$data.eventHub.$emit("show-" + modalName + "-modal");
    }
  }
};
</script>

<style lang="scss">
#status-container {
  margin: 0;
  font-size: 0.8em;
  padding: 12px;
  border-radius: 6px;

  .scenario {
    font-size: 1.15em;
    margin-bottom: 4px;
    display: block;
  }
  .info-button-container {
    padding: 22px 0 0 0;
  }
  .info-button b {
    font-weight: 400;
  }
  a {
    color: #fff;
  }
  .info-button .badge {
    margin: -1px 3px 1px 0;
    background-color: #fff;
    color: #07615e;
    font-size: 10px;
    width: 16px;
    height: 16px;
    padding: 3px 0 0 1px;
  }
}
</style>
